module.exports = __webpack_public_path__ + "img/N1M5.a4c7ed3e.jpg";